import SubjectViewState from '../store/schema/SubjectViewState';
import { ComposeOperation } from '../store/schema/ComposeViewState';

export default function createSubjectViewState(
    composeId: string,
    operation: ComposeOperation,
    subject: string,
    newContent: string
): SubjectViewState {
    return {
        selectionStart: -1,
        selectionEnd: -1,
        inputId: 'subjectLine' + composeId,
    };
}
